import * as actions from './actions';

export const initialState = {
  profiles: {},
  profileVO: {},
  onFetchProfiles: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onFetchProfileVO: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onRequestResetPassword: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onUpdateProfile: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onUpdateUserPassword: {
    asyncStatus: '',
    message: '',
    status: 0
  }
};

export default (state = initialState, action) => {
  if (action.type === actions.types.ON_FETCH_PROFILES_FULFILLED) {
    const { message, profiles, status } = action.data;
    const tempProfiles = {
      1: {
        recordChangeDateTime: 1515080887110,
        recordSyncId: 7087,
        profileUUID: '1',
        firstName: 'John',
        lastName: 'Doe',
        displayName: 'John Doe',
        primaryEmail: 'john.doe@qochealth.com',
        loginId: 'john-doe',
        loginUUID: '1',
        loginStatusUUID: '10245F4D-DB49-4C5D-8408-134F04FA6F23',
        defaultInstanceUUID: 'B30374E4-9805-47CD-BD7A-1E3EC224CC02',
        deleted: false,
        defaultTimeZone: 'America/Toronto',
        roles: ['ROLE_PATIENT']
      },
      2: {
        recordChangeDateTime: 1515080887110,
        recordSyncId: 7087,
        profileUUID: '2',
        firstName: 'Test',
        lastName: 'Sample',
        displayName: 'Test Sample',
        primaryEmail: 'test.sample@qochealth.com',
        loginId: 'test-sample',
        loginUUID: '2',
        loginStatusUUID: 'D93063DC-D8E1-4855-9E86-6155CC03A5A6',
        defaultInstanceUUID: 'B30374E4-9805-47CD-BD7A-1E3EC224CC02',
        deleted: false,
        defaultTimeZone: 'America/Toronto',
        roles: ['ROLE_PATIENT']
      }
    };

    return Object.assign({}, state, {
      profiles: {
        ...profiles,
        ...tempProfiles
      },
      onFetchProfiles: {
        asyncStatus: 'FULFILLED',
        message,
        status
      }
    });
  } else if (action.type === actions.types.ON_FETCH_PROFILES_PENDING) {
    return Object.assign({}, state, {
      onFetchProfiles: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_FETCH_PROFILES_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchProfiles: {
        asyncStatus: 'REJECTED',
        message,
        status
      }
    });
  } else if (action.type === actions.types.ON_FETCH_PROFILE_VO_FULFILLED) {
    const { message, profileVO, status } = action.data;

    return Object.assign({}, state, {
      profileVO,
      onFetchProfileVO: {
        asyncStatus: 'FULFILLED',
        message,
        status
      }
    });
  } else if (action.type === actions.types.ON_FETCH_PROFILE_VO_PENDING) {
    return Object.assign({}, state, {
      onFetchProfileVO: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_FETCH_PROFILE_VO_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchProfileVO: {
        asyncStatus: 'REJECTED',
        message,
        status
      }
    });
  } else if (
    action.type === actions.types.ON_REQUEST_RESET_PASSWORD_FULFILLED
  ) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onRequestResetPassword: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_REQUEST_RESET_PASSWORD_PENDING) {
    return Object.assign({}, state, {
      onFetchLoginStatus: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_REQUEST_RESET_PASSWORD_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onRequestResetPassword: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (action.type === actions.types.ON_UPDATE_PROFILE_FULFILLED) {
    const { message, status, targetProfile } = action.data;

    const isTargetProfileCurrentProfile =
      state.profileVO.profile.profileUUID === targetProfile.profileUUID;
    const profileVO = isTargetProfileCurrentProfile
      ? Object.assign({}, state.profileVO, {
          profile: {
            ...state.profileVO.profile,
            ...targetProfile
          }
        })
      : state.profileVO;

    return Object.assign({}, state, {
      profileVO,
      onUpdateProfile: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_UPDATE_PROFILE_PENDING) {
    return Object.assign({}, state, {
      onUpdateProfile: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_UPDATE_PROFILE_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onUpdateProfile: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (action.type === actions.types.ON_UPDATE_USER_PASSWORD_FULFILLED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onUpdateUserPassword: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_UPDATE_USER_PASSWORD_PENDING) {
    return Object.assign({}, state, {
      onUpdateUserPassword: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_UPDATE_USER_PASSWORD_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onUpdateUserPassword: { asyncStatus: 'REJECTED', message, status }
    });
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/qoc-redux/Profile/reducer.js